<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction" />
    <div class="inner">
      <add-button v-if="$_createActionAllowed" :title="'Přidat konfiguraci bootování' | translate" route-name="deviceBootConfigNew" />
      <h1 v-translate>Konfigurace bootování</h1>
    </div>
    <div class="inner_white">
      <div class="filter search_only">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search" />
        </div>
      </div>

      <div class="table_overflow" id="contentBox" data-table-id="device-boot-configs-list">
        <table class="vypis vypis_detail">
          <thead>
          <tr v-if="entities.length > 0">
            <th class="no_padding drag_drop" />
            <th class="no_padding checkbox" />
            <sorting-table-title
                v-for="title in deviceBootConfigsTableTitles"
                :key="title.key"
                :column="title.column"
                :sort="getActiveSort(title.column)"
                @changeSorting="changeSorting"
            >{{ title.name }}</sorting-table-title>
            <th class="no_padding edit" />
          </tr>
          </thead>

          <tbody>
          <device-boot-config-row
              v-for="entity in entities"
              :entity="entity"
              :key="entity.id"
              :selectedEntities="selectedEntities"
              :ref="'config-row-ref-'+entity.id"
              @deleteEntity="deleteEntity"
              @input="select"
          ></device-boot-config-row>

          <tr v-if="entities.length === 0">
            <td colspan="10">{{ $gettext('Nebyly nalezeny žádné konfigurace.') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="device-boot-configs-list"
          @run-multiple-action="executeMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          @select-all="toggleSelectAll"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import listActions from "@/components/mixins/list-actions"
import DeviceBootConfigRow from "./DeviceBootConfigRow.vue";

export default {
  name: 'DeviceBootConfigsList',
  components: {
    DeviceBootConfigRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'deviceBootConfigs',
      entitiesKey: 'device_boot_configs',
      formFields: {
        search: null,
        mac_address: null,
        serial_number: null,
        sort: {
          column: 'sName',
          direction: 'desc',
        },
      },
    }
  },
  created(DeviceBootConfigService) {
    this.entityService = DeviceBootConfigService;

    this.createdInit()
  },
  computed: {
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        {value: 'delete-multi', text: this.$gettext('Smazat')}
      ];
    },
    deviceBootConfigsTableTitles() {
      return [
        {key: 1, name: this.$gettext('Bootcast ID'), column: 'sName'},
        {key: 2, name: this.$gettext('Verze image'), column: 'sImageVersion'},
        {key: 3, name: this.$gettext('Verze splash'), column: 'sSplashVersion'},
        {key: 4, name: this.$gettext('Operátor')},
        {key: 5, name: this.$gettext('Zařízení')},
        {key: 6, name: this.$gettext('Vloženo'), column: 'sDateCreated'},
        {key: 7, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},

      ];
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.deviceBootConfigsTableTitles)
    },
  },
  methods: {
    executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.deleteEntity(actionIds);
          break;
        default:
          this.runMultipleAction(action, activeKey);
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceBootConfigs/DeviceBootConfigsList.vue